import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { loadModules } from 'esri-loader';
import { environment } from '../../../environments/environment';
import esri = __esri; // Esri TypeScript Types

let BCList;
let websiteUrl;
let kpiId;
let year;
let quarter;

@Component({
  selector: 'app-esri-maps',
  templateUrl: './esri-maps.component.html',
  styleUrls: ['./esri-maps.component.css']
})
export class EsriMapsComponent implements OnInit {

  @ViewChild('mapViewNode', { static: true }) private mapViewEl: ElementRef;
  @Input() renderedArray: any;
  @Input() kpiId: any;
  @Input() year: any;
  @Input() quarter: any;

  mapCenter = [29.8206, 22.8025];
  basemapType = 'gray';
  mapZoomLevel = 3;
  
  constructor() { }

  ngOnInit() {
    BCList = this.renderedArray;
    this.initializeMap().then((mapView) => {
      this.houseKeeping(mapView);
    });
    console.log(this.kpiId, this.year, this.quarter);
    kpiId = this.kpiId;
    year = this.year;
    quarter = this.quarter;
    // let url = window.location.href;
    // let arr = url.split("/");
    websiteUrl = environment.clientRoot;
  }


  FillPopUpList(feature)
  {
    let attributes = feature.graphic.attributes;
    //console.log(this.renderedArray);
    console.log(attributes);
    // let content = "<ul " + "class='list-group popup-esri'" + ">";
    let content = '';
    let BCInnerList = BCList.filter((item) => item.code == attributes.MAPID);
    console.log(BCInnerList);

    for(let i = 0; i < BCInnerList.length; i++)
    {
      content += '<a href="' + websiteUrl + 'home/bc-focus/' + BCInnerList[i].bcId +'/' + kpiId +'/' + year +'/' + quarter+'"> ' + BCInnerList[i].name+'';
      if(BCInnerList[i].color == "green")
        content += '<span style="background-color:green;"></span>';
      else if(BCInnerList[i].color == "yellow")
        content += '<span style="background-color:yellow;"></span>';
      else if(BCInnerList[i].color == "red")
        content += '<span style="background-color:red;"></span>';
      else if(BCInnerList[i].color == "gray")
        content += '<span style="background-color:gray;"></span>';

      content += "</a>";
    }
    // content += "</ul>";

    return content;
  }

  async initializeMap() {
    try {

      // Load the modules for the ArcGIS API for JavaScript
      const [EsriMap, EsriMapView, FeatureLayer, Query, QueryTask, Graphic, PopupTemplate, Field, SimpleRenderer, UniqueRenderer, Label] = await loadModules([
        'esri/Map',
        'esri/views/MapView',
        "esri/layers/FeatureLayer",
        "esri/tasks/support/Query",
        "esri/tasks/QueryTask",
        "esri/Graphic",
        "esri/PopupTemplate",
        "esri/layers/support/Field",
        "esri/renderers/SimpleRenderer",
        "esri/renderers/UniqueValueRenderer",
        "esri/layers/support/LabelClass"
      ]);

      // Configure the Map
      const mapProperties: esri.MapProperties = {
        basemap: this.basemapType
      };

      const map: esri.Map = new EsriMap(mapProperties);

      // Initialize the MapView
      const mapViewProperties: esri.MapViewProperties = {
        container: this.mapViewEl.nativeElement,
        center: this.mapCenter,
        zoom: this.mapZoomLevel,
        map: map,
        popup: {
          dockEnabled: true,
          dockOptions: {
            // Disables the dock button from the popup
            buttonEnabled: false,
            // Ignore the default sizes that trigger responsive docking
            breakpoint: false
          },
          collapseEnabled : false
        }
      };



      const popuptempprop: esri.PopupTemplateProperties = {
        title: 'Country',
        // content: [{
        //   type: "fields",
        //   fieldInfos: [{
        //     fieldName: "ADM0_NAME",
        //     visible: true,
        //     label: "Country Name"
        //   }]
        // }]
        content: this.FillPopUpList
      };
      const popuptemp: esri.PopupTemplate = new PopupTemplate(popuptempprop);

      var DefaultSymbol = {
        type: "simple-fill",  // autocasts as new SimpleFillSymbol()
        color: "lightgrey",
        style: "solid",
        outline: {  // autocasts as new SimpleLineSymbol()
          color: "white",
          width: 1
        }
      };

      let RenderedUniqueValues = [];
      //for each country push the color object
      let showonMap = this.renderedArray.filter((item) => item.showOnMap);
      for(let i =0; i < showonMap.length; i++){
        RenderedUniqueValues.push({ value: showonMap[i].code, symbol: { type: "simple-fill", color: showonMap[i].color } });
      }
      // RenderedUniqueValues.push({ value: "EGY", symbol: { type: "simple-fill", color: "red" } });
      const MyUniqueRenderer: esri.UniqueValueRenderer = new UniqueRenderer({
        defaultSymbol: DefaultSymbol,
        field: "MAPID",
        uniqueValueInfos: RenderedUniqueValues
      })

      const Lable = new Label({
        symbol: {
          type: "text",  // autocasts as new TextSymbol()
          color: "black",
          font: {  // autocast as new Font()
            family: "Playfair Display",
            size: 10
          }
        },
        //labelPlacement: "above-center",
        labelExpressionInfo: {
          expression: "$feature.COUNTRY"
        }
      });

      const featurelayerprop: esri.FeatureLayerProperties = {
        url: "https://services.arcgis.com/5T5nSi527N4F7luB/arcgis/rest/services/EMRO_WHO_Custom/FeatureServer",
        outFields: ["*"],
        id: "countriesLayer",
        renderer: MyUniqueRenderer,
        popupTemplate: popuptemp,
        labelingInfo: [Lable]
      }

      const emrfeaturelayer: esri.FeatureLayer = new FeatureLayer(featurelayerprop);

      return {
        mapview: new EsriMapView(mapViewProperties),
        map: map,
        featurelayer: emrfeaturelayer
      };

    } catch (error) {
      console.log('EsriLoader: ', error);
    }

  }


  async houseKeeping(data) {

    data.mapview.when(()=>{
      data.map.layers.add(data.featurelayer);
    });
  }

}
